export const CONFIG = {
    url: 'https://api.ct4y.com',
    // url: 'http://psycho.loc',


    tables: {
        user: 'Пользователи',
        therapist: 'Терапевты',
        therapist_schedule: 'Расписание терапевтов',
        card: 'Карты пациентов',
        therapist_activity: 'Активности терапевтов',
        therapist_education: 'Образование терапевтов',
        therapist_qualification: 'Квалификации терапевтов',
        therapist_service: 'Сервисы терапевтов',
        certification: 'Сертификаты терапевтов',
        speciality: 'Список специальностей',
        image: 'Изображения',
        news: 'Новости',
        // test: 'Тесты',
        // test_question: 'Вопросы тестов',
        // test_answer: 'Ответы к тестам',
        test_user: 'Пользователь-Тест',
        test_user_answer: 'Ответы пользователей на тесты',
        // test_result: 'Расшифровка баллов тестов',
        payment: 'Платежи',
        plan: 'Планы подписка',
        plan_subscription: 'Подписки терапевтов',
        banner: 'Баннеры',
        config: 'Конфиги',
        association: 'Ассоциации терапевтов',
        translate: 'Переводы',
        center: 'Центры',
        center_user: 'Терапевты в центрах'

    },

    forms: {
        news: 'Новости'
    },
};
